module.exports = __webpack_public_path__ + "img/gb.dc204662.svg";